<template>
	<c-dialog ref="dialog" title="设置项目人员" width="750" height="500" button-name="确认并提交" @resolve="submitHandle">
		<c-form ref="form" unit-width="400">
			<c-form-item type="hidden" name="project_id"></c-form-item>
			<c-form-item type="input" label="项目经理" name="xmjl_xm" required></c-form-item>
			<c-form-item type="input" label="项目经理电话" name="xmjl_lxdh" required></c-form-item>
			<c-form-item type="input" label="技术总工" name="jszg_xm" required></c-form-item>
			<c-form-item type="input" label="技术总工电话" name="jszg_lxdh" required></c-form-item>
			<c-form-item type="input" label="安全员" name="aqy_xm" required></c-form-item>
			<c-form-item type="input" label="安全员电话" name="aqy_lxdh"></c-form-item>
			<c-form-item type="input" label="施工员" name="sgy_xm" required></c-form-item>
			<c-form-item type="input" label="施工员电话" name="sgy_lxdh"></c-form-item>
			<c-form-item type="input" label="质检员" name="zjy_xm" required></c-form-item>
			<c-form-item type="input" label="质检员电话" name="zjy_lxdh"></c-form-item>
			<c-form-item type="textarea" label="备注说明" name="remark"></c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		methods: {
			open(id) {
				this.$refs.form.clear();
				this.$refs.form.set({
					project_id: id
				});
				this.$refs.dialog.open();
			},
			
			submitHandle(stop, next) {
				stop();
				
				this.$refs.form.submit({
					url: '/project/ry/add',
					rule: {
						xmjl_xm: '请填写项目经理',
						xmjl_lxdh: '请填写项目经理电话',
						jszg_xm: '请填写技术总工',
						jszg_lxdh: '请填写技术总工电话',
						aqy_xm: '请填写安全员',
						sgy_xm: '请填写施工员',
						zjy_xm: '请填写质检员'
					},
					success: () => {
						next();
						this.$message({
							text: '提交成功'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>